import { render, staticRenderFns } from "./productModfiyPage.vue?vue&type=template&id=e3bce01a&scoped=true&"
import script from "./productModfiyPage.vue?vue&type=script&lang=js&"
export * from "./productModfiyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bce01a",
  null
  
)

export default component.exports